import { render, staticRenderFns } from "./zhutitu.vue?vue&type=template&id=72ed5a9e&scoped=true&"
import script from "./zhutitu.vue?vue&type=script&lang=js&"
export * from "./zhutitu.vue?vue&type=script&lang=js&"
import style0 from "./zhutitu.vue?vue&type=style&index=0&id=72ed5a9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ed5a9e",
  null
  
)

component.options.__file = "zhutitu.vue"
export default component.exports